// removed by extract-text-webpack-plugin
module.exports = {"appStoreLinksContainer":"Ge883c9"};